"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHTMLElementsFromHtml = void 0;
var html_importer_1 = require("../../html/import/html-importer");
function getHTMLElementsFromHtml(inputController, html) {
    inputController.setEditableDocumentContent(html_importer_1.HtmlImporter.convertHtml(html));
    var editableElement = inputController.getEditableDocument();
    var elementsContainer = editableElement.body || editableElement;
    return elementsContainer.childNodes;
}
exports.getHTMLElementsFromHtml = getHTMLElementsFromHtml;
